import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\AdminPanel\PaymentEventsController::index
* @see app/Http/Controllers/AdminPanel/PaymentEventsController.php:28
* @route '/admin-panel/payment-events'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin-panel/payment-events',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AdminPanel\PaymentEventsController::index
* @see app/Http/Controllers/AdminPanel/PaymentEventsController.php:28
* @route '/admin-panel/payment-events'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\PaymentEventsController::index
* @see app/Http/Controllers/AdminPanel/PaymentEventsController.php:28
* @route '/admin-panel/payment-events'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\PaymentEventsController::index
* @see app/Http/Controllers/AdminPanel/PaymentEventsController.php:28
* @route '/admin-panel/payment-events'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AdminPanel\PaymentEventsController::index
* @see app/Http/Controllers/AdminPanel/PaymentEventsController.php:28
* @route '/admin-panel/payment-events'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\PaymentEventsController::index
* @see app/Http/Controllers/AdminPanel/PaymentEventsController.php:28
* @route '/admin-panel/payment-events'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\PaymentEventsController::index
* @see app/Http/Controllers/AdminPanel/PaymentEventsController.php:28
* @route '/admin-panel/payment-events'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\AdminPanel\PaymentEventsController::replay
* @see app/Http/Controllers/AdminPanel/PaymentEventsController.php:61
* @route '/admin-panel/payment-events/{paymentEvent}/replay'
*/
export const replay = (args: { paymentEvent: string | number | { id: string | number } } | [paymentEvent: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: replay.url(args, options),
    method: 'post',
})

replay.definition = {
    methods: ["post"],
    url: '/admin-panel/payment-events/{paymentEvent}/replay',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AdminPanel\PaymentEventsController::replay
* @see app/Http/Controllers/AdminPanel/PaymentEventsController.php:61
* @route '/admin-panel/payment-events/{paymentEvent}/replay'
*/
replay.url = (args: { paymentEvent: string | number | { id: string | number } } | [paymentEvent: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { paymentEvent: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { paymentEvent: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            paymentEvent: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        paymentEvent: typeof args.paymentEvent === 'object'
        ? args.paymentEvent.id
        : args.paymentEvent,
    }

    return replay.definition.url
            .replace('{paymentEvent}', parsedArgs.paymentEvent.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\PaymentEventsController::replay
* @see app/Http/Controllers/AdminPanel/PaymentEventsController.php:61
* @route '/admin-panel/payment-events/{paymentEvent}/replay'
*/
replay.post = (args: { paymentEvent: string | number | { id: string | number } } | [paymentEvent: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: replay.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AdminPanel\PaymentEventsController::replay
* @see app/Http/Controllers/AdminPanel/PaymentEventsController.php:61
* @route '/admin-panel/payment-events/{paymentEvent}/replay'
*/
const replayForm = (args: { paymentEvent: string | number | { id: string | number } } | [paymentEvent: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: replay.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AdminPanel\PaymentEventsController::replay
* @see app/Http/Controllers/AdminPanel/PaymentEventsController.php:61
* @route '/admin-panel/payment-events/{paymentEvent}/replay'
*/
replayForm.post = (args: { paymentEvent: string | number | { id: string | number } } | [paymentEvent: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: replay.url(args, options),
    method: 'post',
})

replay.form = replayForm

const paymentEvents = {
    index: Object.assign(index, index),
    replay: Object.assign(replay, replay),
}

export default paymentEvents